// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".primary-button[data-v-6e54fa70]{margin-top:16px;max-width:150px}.voucher-info-title[data-v-6e54fa70]{margin-top:16px;font-weight:700;margin-bottom:-8px}.voucher-validity[data-v-6e54fa70]{margin-top:16px;font-weight:bolder}", ""]);
// Exports
module.exports = exports;
